<template>
  <v-dialog v-model="dialog" width="1000" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon>business</v-icon>
        {{ form.id ? $t("parametro.crud.editParametro") : "Editar" }}
        <v-spacer />
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          Datos Básicos

          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs3>
                <v-autocomplete
                  v-model="persona.id_tipo_documento"
                  :items="tipo_de_documentos"
                  item-text="descripcion"
                  :item-value="val => parseInt(val.id)"
                  label="Tipo de documento"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  @change="obtenerNrodoc()"
                  label="Número de Documento"
                  :rules="$validate(['required'])"
                  required
                  v-model="persona.nro_doc"
                  maxlength="50"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  label="Complemento"
                  id="complemento"
                  required
                  v-model="persona.nro_complemento"
                  maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-autocomplete
                  v-model="persona.expedido"
                  :items="tipo_expedido"
                  item-text="valor"
                  item-value="valor"
                  :rules="$validate(['required'])"
                  label="Expedido en"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2>
                <v-select
                  label="Sexo"
                  :items="generos"
                  item-text="nombre"
                  item-value="value"
                  :rules="$validate(['required'])"
                  required
                  v-model="persona.sexo"
                  maxlength="1"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  label="Apellido Paterno"
                  v-model="persona.ap_paterno"
                  maxlength="50"
                  class="mayuscula"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Apellido Materno"
                  v-model="persona.ap_materno"
                  maxlength="50"
                  class="mayuscula"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  label="Apellido Casada"
                  required
                  v-model="persona.ap_casada"
                  maxlength="50"
                  class="mayuscula"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nombres"
                  :rules="$validate(['required'])"
                  required
                  v-model="persona.nombres"
                  maxlength="50"
                  class="mayuscula"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          Usuario
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  label="Nombre Usuario"
                  disabled
                  v-model="persona.usuarios[0].nombre_usuario"
                  maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Correo Electrónico"
                  disabled
                  v-model="persona.usuarios[0].correo"
                  maxlength="50"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :disabled="!valid"
            :loading="loading"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    }
  },
  data() {
    return {
      dialog: false,
      form: {},
      persona: {
        usuarios: [
          {
            nombre_usuario: "",
            correo: ""
          }
        ]
      },
      movilidad: {},
      valid: true,
      tipo_de_documentos: [],
      tipo_expedido: [],
      tipo_cargo: [],
      tipo_puesto: [],
      unidades: [],
      movilidad: {},
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      estado_boton: false,
      generos: [
        { value: "M", nombre: "MASCULINO" },
        { value: "F", nombre: "FEMENINO" }
      ],
      loading: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogEditarPersona", item => {
      console.log(item.id_persona);
      this.obtenerPersona(item.id_persona);
      this.dialog = true;
    });
    this.obtenerTipoDocumentos();
    this.obtenerTipoExpedicion();
  },

  methods: {
    async obtenerPersona(id_persona) {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            persona(id:${id_persona}){
							id
              id_tipo_documento
							nro_doc
							nro_complemento
							expedido
							sexo
							ap_paterno
							ap_materno
							ap_casada
							nombres
							usuarios{
								nombre_usuario
								correo
								id
							}
						}
          }
        `
      });
      let aux = [{ nombre_usuario: "", correo: "" }];
      if (respuesta.persona.usuarios.length > 0) {
        this.persona = respuesta.persona;
      } else {
        this.persona = respuesta.persona;
        this.persona.usuarios = aux;
      }

      this.persona.id_tipo_documento = parseInt(this.persona.id_tipo_documento);
      this.persona.id_persona = id_persona;
    },

    close() {
      this.dialog = false;
      this.persona = {
        usuarios: [
          {
            nombre_usuario: "",
            correo: ""
          }
        ]
      };
      this.movilidad = {};
      this.form = {};
      this.date = new Date().toISOString().substr(0, 10);
      this.$bus.$emit("closeDialog");
    },
    prueba() {
      //console.log('evento ACTIVADO: ', this.form.item)
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    // async verificaItemprueba() {
    //   let respuesta = await this.$service.graphql({
    //     query: `
    //       query{
    //         runQuery(consulta:"select movilidad.fn_valida_item(${this.movilidad.item})"){
    //           respuesta
    //         }
    //       }
    //     `,
    //   });

    //   if (respuesta.runQuery.respuesta[0].fn_valida_item == 1) {
    //     //this.$message.error('Item Ocupado');
    //     this.estado_boton = true;
    //   }
    //   if (respuesta.runQuery.respuesta[0].fn_valida_item == 0) {
    //     this.$message.error("Item Ocupado");
    //     this.estado_boton = false;
    //   }
    //   if (respuesta.runQuery.respuesta[0].fn_valida_item == -1) {
    //     this.$message.error("Item Inexistente");
    //     this.estado_boton = false;
    //   }
    // },
    async obtenerTipoDocumentos() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
          	tipoDocumentos{
          		rows{
          			id
          			descripcion
          		}
          	}
          }
          `
      });
      //console.log(respuesta)
      this.tipo_de_documentos = respuesta.tipoDocumentos.rows;
    },
    async obtenerNrodoc() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            personas(nro_doc:"${this.form.nro_doc}"){
              rows{
                id
                ap_paterno
                ap_materno
                ap_casada
                nombres
                id_tipo_documento
                nro_doc
                nro_complemento
                sexo
              }
            }
          }
        `
      });
      console.log("personaaaaa", respuesta);
      if (respuesta.personas.rows.length > 0) {
        respuesta.personas.rows[0].id_tipo_documento = parseInt(
          respuesta.personas.rows[0].id_tipo_documento
        );
        this.persona = respuesta.personas.rows[0];
      }

      //console.log(this.persona)
      //this.form = respuesta.personas.rows[0];
    },
    async obtenerTipoExpedicion() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            params(tipo:"CARNET DE IDENTIDAD"){
              rows{
                id
                valor
              }
            }
          }
        `
      });
      //console.log(respuesta)
      this.tipo_expedido = respuesta.params.rows;
    },

    async save() {
      //console.log(this.persona)
      //id:this.persona.id_persona

      if (this.persona.ap_paterno === "" && this.persona.ap_materno === "") {
        this.$message.error("Falta Apellido Paterno o Apellido Materno");
      } else {
        this.loading = true;
        let user = this.$storage.get("user");
        if (this.persona.nro_complemento == null) {
          this.persona.nro_complemento = "";
        }
        if (this.persona.ap_casada == null) {
          this.persona.ap_casada = "";
        }
        this.movilidad.fecha = this.date;
        let respuesta;
        try {
          respuesta = await this.$service.graphql({
            query: `
          query{
            runQuery(consulta:"select persona.fn_modif_persona_basico(${
              this.persona.id_persona
            },${this.persona.id_tipo_documento},'${this.persona.nro_doc}','${
              this.persona.nro_complemento
            }','${this.persona.expedido}','${
              this.persona.sexo
            }','${this.persona.ap_paterno.toUpperCase()}','${this.persona.ap_materno.toUpperCase()}','${this.persona.ap_casada.toUpperCase()}','${this.persona.nombres.toUpperCase()}',${
              user.id
            })"){
              respuesta
            }
          }
        `
          });
          console.log(respuesta);
          this.$message.success();
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
        this.close();
        this.$bus.$emit(
          "closeDialogCreado",
          respuesta.runQuery.respuesta[0].fn_modif_persona_basico
        );
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/EditarPersona.vue